import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
import qs from 'qs';

interface Params {
  [key: string]: any;
}

const ROUTES = {
  scoreRecharge: '/sixshot/scores/recharge/index',
  scoreRechargeSuccess: '/sixshot/scores/recharge/success/index',
  video: '/payment/video',
  videoDetail: '/payment/videoDetail',
  help: '/other/help',
  advice: '/other/advice',

  rentVipDetail: '/payment/rentvipdetail',
  rentVipCompaire: '/payment/rentvipcompaire',
  rentVipRights: '/rent/vip/rights',

  trunkVipDetail: '/payment/trunkvipdetail',
};

type Router = keyof typeof ROUTES;

/**
 * 返回
 *
 * @returns
 */
function back() {
  return history.goBack();
}

function constructUrl(router: Router, params?: Params) {
  let url = ROUTES[router];

  if (params) {
    url += '?' + qs.stringify(params);
  }

  return url;
}

/**
 * 前进
 *
 * @param {Router} router
 * @param {Params} [params]
 * @returns
 */
function push(router: Router, params?: Params) {
  return history.push(constructUrl(router, params));
}

/**
 * 重定向
 *
 * @param {Router} router
 * @param {Params} [params]
 * @returns
 */
function redirect(router: Router, params?: Params) {
  return history.replace(constructUrl(router, params));
}

/**
 * 重新加载
 *
 * @param {Router} router
 * @param {Params} [params]
 * @returns
 */
function reLaunch(router: Router, params?: Params) {
  window.location.href = window.location.origin + constructUrl(router, params);
}

function getParams(url:string){
  //应该用qs.parse的。。。
  let reg_url =/^[^\?]+\?([\w\W]+)$/,
      reg_para=/([^&=]+)=([\w\W]*?)(&|$)/g, //g is very important
      arr_url = reg_url.exec( url ),
      ret        = {};
  if( arr_url && arr_url[1] ){
      let str_para = arr_url[1],result;
      while((result = reg_para.exec(str_para)) != null){
          ret[result[1]] = result[2];
      }
  }
  return ret;
}

export default {
  back,
  push,
  reLaunch,
  redirect,
  getParams
};
